<template>
<div class="chapter">
<div class="inner_page">
<div class="fm">
<h2 class="fmtitle"><a id="page_2"><span class="bold">Dedication</span></a></h2><a id="page_2">
<p class="noindent"><em class="italic">I would like to dedicate this book to my dear cousin, Hiroko Yamada, with whom I share lots of childhood memories.</em></p>
</a></div><a id="page_2">
<div class="img_container">
<img alt="image" src="images/pg4-1.jpg"/>
</div>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Dedication.vue?08431794